import React from "react";
import { Link } from "react-router-dom";

const Cancel = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 satin-bg" data-testid="checkout-cancel-page">
      <div className="text-center max-w-xl">
        <h1 className="font-serif text-4xl md:text-6xl font-light text-[#1A1612] mb-6">
          Plată anulată
        </h1>
        <div className="sep-line max-w-xs mx-auto mb-8">
          <span className="diamond" />
        </div>
        <p className="text-[#6E665A] text-lg mb-12 font-light leading-relaxed">
          Comanda ta nu a fost finalizată. Poți relua oricând.
        </p>
        <Link to="/" className="btn-pill inline-flex" data-testid="cancel-back-button">
          Înapoi pe site
        </Link>
      </div>
    </div>
  );
};

export default Cancel;
